





















































































































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import TroskoviPoGodinama from './widgets/PCTroskoviPoGodinama.vue';
import UcesceTroskova from './widgets/UcesceTroskova.vue';
import TroskoviPoGrupama from './widgets/PCTroskoviPoGrupama.vue';
import TroskoviVozila from './widgets/TroskoviVozila.vue';
import {State} from "vuex-class";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {Dashboard, InventarskiVozniPark, PredjeniKilometri, UkupniTrosak} from "@/services/BackendProxies";
import dataProxy from '@/services/data-proxy.service'

@Component({components: {TroskoviPoGodinama, UcesceTroskova, TroskoviPoGrupama, TroskoviVozila}})
export default class DashboardComponent extends mixins(ComponentBaseMixin) {
    @State loggedUser: string;
    @State permissions;

    dashboard: Dashboard = Dashboard.fromJS({
        ucesceUUkupnimTroskovima: {},
        inventarskiVozniPark: new InventarskiVozniPark(),
        ukupniTrosak: new UkupniTrosak(),
        predjeniKilometri: new PredjeniKilometri()
    });

    async created() {
        this.dashboard = await this.loadData(() => dataProxy.vratiDashboard())();
    }

    get hasDashboardPermission() {
        // return this.permissions && this.permissions.indexOf('dashboard') > -1;
        return true;
    }
}
